import { render, staticRenderFns } from "./EditTransporterStatus.vue?vue&type=template&id=63ddbec4&scoped=true&"
import script from "./EditTransporterStatus.vue?vue&type=script&lang=js&"
export * from "./EditTransporterStatus.vue?vue&type=script&lang=js&"
import style0 from "./EditTransporterStatus.vue?vue&type=style&index=0&id=63ddbec4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ddbec4",
  null
  
)

export default component.exports